<template>
    <div class="humans-table">
        <people-list-item v-for="employee in list"
                          :key="employee.id"
                          :active="employee.id===activeId"
                          :employee="employee"
                          :show-quetionnaire="showQuetionnaire">
        </people-list-item>
    </div>
</template>

<script>
    import PeopleListItem from "./PeopleListItem";

    export default {
        name: 'people-list',
        components: {
            PeopleListItem,
        },
        props: {
            list: Array,
            showQuetionnaire: {
                type: Boolean,
                default: false
            },
            activeId: Number
        },
    }
</script>

<style scoped>
</style>
